<svelte:options runes={true} />

<script lang="ts">
  import type { ClassValue } from "svelte/elements";
  import type { Snippet } from "svelte";

  interface Props {
    as?: "div" | "span";
    children?: Snippet;
    class?: ClassValue;
  }

  let { as = "div", children, class: className = "" }: Props = $props();
</script>

<svelte:element this={as} class={["da-empty-state", className]}>
  {#if children}
    {@render children()}
  {:else}
    No results
  {/if}
</svelte:element>

<style>
  @layer aurora {
    .da-empty-state {
      font-family: var(--da-font-family-primary);
      font-size: var(--da-font-size-sm);
      color: var(--da-color-charcoal-700);
      text-align: center;
      padding-block: var(--da-space-4);
    }
  }
</style>
